import ActionTypeServicio from "../ActionTypeServicio";

export default class CargaDeServiciosBuscados extends ActionTypeServicio {
    ejecutar(estado, nuevoEstado) {
        nuevoEstado.flag.procesandoComando = false;
        nuevoEstado.data = this.payload;
        return nuevoEstado;
    }
}
